module.exports = __webpack_public_path__ + "assets/img/block-right-hover-8c942d89.png";